import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_SIGNUP_CONFIG_ACTION_TYPE } from '../actions';

const initialState = {
  // { tpoSignupConfigurationId, name, createdDate } or null.
  config: null,
};

const subCompanySignupConfigReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_SIGNUP_CONFIG_ACTION_TYPE.GET:
        draft.config = payload || null;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanySignupConfigReducer;
